import {AnyAction} from 'redux';
import {SET_CARBON_OUTPUT, SET_CARBON_TARGET} from '../action';


/**
 * set the target level for carbon-neutral output
 */
export function setCarbonOutput(carbon_output: number) : AnyAction
{
    return {type: SET_CARBON_OUTPUT, payload: {carbon_output}};
}


/**
 * set the target level for carbon-neutral power
 */
export function setCarbonTarget(carbon_target: number) : AnyAction
{
    console.log('updating carbon target:', carbon_target);

    return {type: SET_CARBON_TARGET, payload: {carbon_target}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/carbon/setCarbonTarget.ts